import React, { useEffect, useState } from 'react';

import '../assets/scss/profile.scss';
import UserStore from '../store/UserStore';
import Header from '../components/common/Header';
import RatingStore from '../store/RatingStore';
import { observer } from 'mobx-react';
import { formatTime, numWord } from '../utils/utils';
import { runInAction } from 'mobx';
import { useNavigate } from 'react-router-dom';

function getScoreColor(score: number, maxScore: number) {
  const step = maxScore / 6;
  if (score >= maxScore - step * 4 + 1 && score <= maxScore - step * 3)
    return { color: '#1ce400', background: '#084a00' };
  else if (score >= maxScore - step * 3 + 1 && score <= maxScore - step * 2)
    return { color: '#ffc800', background: '#654f00' };
  else if (score >= maxScore - step * 2 + 1 && score <= maxScore - step * 1 - 1000)
    return { color: '#ff6309', background: '#652703' };
  else if (score >= maxScore - step * 1 + 1 - 1000)
    return { color: '#fe1f00', background: '#640b00' };
  else
    return { color: '#eeeeee', background: '#545454' };
}

function parseSex(s: number | undefined): string {
  if (!s) return 'Не указан';

  switch (s) {
    case 1:
      return 'Мужской';
    case 2:
      return 'Женский';
    default:
      return 'Не указан';
  }
}

const formatDate = (date: string | undefined): string => {
  if (date) {
    const parts = date.split('.');

    return `${parts[1]}.${parts[0]}.${parts[2]}`;
  }
  
  return 'Не указана';
};

const ProfilePage: React.FC = observer(() => {
  const navigate = useNavigate();
  const [online, setOnline] = useState<boolean>(false);
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (!fetched) {
      RatingStore.fetchMaps();
      RatingStore.fetchUsers();
      UserStore.fetchGames();
      setFetched(true);
    }
  }, [fetched, setFetched]);
  
  function rating(score: number) {
    const colors = getScoreColor(score, 15000);
    return (
      <div className='sr__profile__stat__data'>
        <div className="score" style={{ background: colors.background }}>
          <div className="lines">
            <div className="line" style={{ background: colors.color }} />
            <div className="line" style={{ background: colors.color, marginLeft: '.125rem' }} />
          </div>
          <div
            className="value"
            style={{
              color: colors.color,
              textWrap: 'nowrap'
            }}
          >
            {(Math.floor(score * 10) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',')}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <Header />
      <div className='sr__profile'>
        <div className='container'>
          <div className='sr__profile__inner'>
            <div className='sr__profile__header'>
              <div className='sr__basic__information'>
                <div
                  className='sr__profile__photo'
                  style={{
                    backgroundImage: UserStore.photo ? `url('https://scoreflect.ru/static/${UserStore.photo}')` : '',
                    backgroundSize: UserStore.photo ? 'cover' : ''
                  }}
                >{online ? <div className='sr__profile__online' /> : <></>}</div>
                {UserStore.nickName ? <div className='sr__profile__nickname'>{UserStore.nickName}</div> : null}
                <div className='sr__profile__id'>ID: {UserStore.shortId}</div>
              </div>
              <div className='sr__profile__userData'>
                <p className='sr__profile__userData__item'>Имя: <b>{UserStore.firstName ?? 'Не указано'}</b></p>
                <p className='sr__profile__userData__item'>Фамилия: <b>{UserStore.lastName ?? 'Не указана'}</b></p>
                <p className='sr__profile__userData__item'>Номер телефона: <b>{UserStore.phoneNumber ?? 'Не указан'}</b></p>
                {/*<p className='sr__profile__userData__item'>E-Mail: <b>{UserStore.email ?? 'Не указан'}</b></p>*/}
                <p className='sr__profile__userData__item'>Пол: <b>{parseSex(UserStore.sex)}</b></p>
                {/*<p className='sr__profile__userData__item'>Дата рождения: <b>{formatDate(UserStore.birthday)}</b></p>*/}
                <button className='sr__profile__userData--button' onClick={() => navigate('/settings')}>Редактировать</button>
              </div>
            </div>
            {RatingStore.users.map((user, index) => {
              if (user.UserID === UserStore.id) {
                return <div className='sr__profile__stat' key={user.NickName}>
                <div className='sr__profile__stat__item'>
                  <div className='sr__profile__stat__data'>{index+1}</div>
                  <div className='sr__profile__stat__title'>Рейтинг</div>
                </div>
                <div className='sr__profile__stat__item'>
                  {rating(user.Score)}
                  <div className='sr__profile__stat__title'>Очки</div>
                </div>
                <div className='sr__profile__stat__item'>
                  <div className='sr__profile__stat__data'>{UserStore.games.length}</div>
                  <div className='sr__profile__stat__title'>Сыграно</div>
                </div>
              </div>
              }
            })}
            {UserStore.days.map((day) => {
              

              return <div key={day.Day} className='sr__profile__day'>
                <div className='sr__profile__day__header' onClick={() => runInAction(() => {day.Opened = !day.Opened})}>{day.Day}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{day.Games.length} {numWord(day.Games.length, ['игра', 'игры', 'игр'])}</div>
                <div className='sr__profile__day__body' style={{ display: day.Opened ? 'block' : 'none' }}>
                  {day.Games.map((game) => {
                    const map = RatingStore.maps.find(x => x.ID === game.MapID);
                    const date = new Date(game.CreatedAt);
                    return <div key={game.Time} className='sr__profile__day__body--game'>
                      <p>{date.toLocaleTimeString()}</p>
                      <p style={{ width: '60%' }}>{map?.Title}</p>
                      <p><b>{formatTime(game.Time)}</b></p>
                    </div>;
                  })}
                </div>
              </div>;
            })}
          </div>
        </div>
      </div>
    </>
  );
});

export default ProfilePage;